import React from "react";
import "./loading-overlay-cpl.css";

const LoadingOverlay = ({ show = false }) => {
  if (!show) return null;

  return (
    <div className="overlay-cpl">
      <div className="overlay-content-cpl">
        <div className="spinner-cpl"></div>
        <p className="overlay-text-cpl">Veuillez patientez..</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
